import APP from 'app';

const sendAccessDeniedResponse = () => {
    return {
        status: {
            success: false,
            httpStatus: 403
        },
        errors: [
            {
                errCode: 403,
                message: 'Access Denied'
            }
        ]
    }
}

const validateUser = (headers) => {
    const { authorization = '' } = headers;

    if (!APP.Utils.isEmpty(authorization) && authorization !== 'undefined' && typeof authorization === 'string') {
        const { userId = '' } = APP.Utils.getUserInfoFromJwt() || {};
        const { userId: resUserId = '' } = APP.Utils.getUserInfoFromJwt(authorization) || {};
        if (userId === resUserId) {
            return {
                validUser: true
            };
        }
        return {
            validUser: false,
            accessDeniedData: sendAccessDeniedResponse()
        };
    }
    return {
        validUser: true
    };
};

export default validateUser;
